import React, { type Element } from 'react';
import { stylesColors } from 'angieslist-styles';
import { Label } from 'angieslist-react-components';

type Props = {
  licenseVerificationStatus: string
}

export const LicenseVerificationStatusPill = ({
  licenseVerificationStatus,
}: Props): Element<"span"> => {
  const pillColorMapping = {
    Unverified: stylesColors.grey400,
    Expired: stylesColors.danger300,
    Revoked: stylesColors.danger300,
    Excluded: stylesColors.danger300,
    'No Longer Available': stylesColors.grey400,
    'Awaiting Verification': stylesColors.secondary300,
    Incomplete: stylesColors.tertiary300,
    Verified: stylesColors.primary300,
  };

  const status = pillColorMapping[licenseVerificationStatus] ? licenseVerificationStatus : 'Unverified';

  const style = {
    color: pillColorMapping[status],
    borderColor: pillColorMapping[status],
  };

  return (
    <span>
      <Label style={style} className={`License-Verification-Status-Pill-${licenseVerificationStatus}`}>
        {status}
      </Label>
    </span>
  );
};

export default (LicenseVerificationStatusPill);




// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/LicenseVerificationStatusPill.js